import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/store/auth';

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/LoginView.vue')
  },

  {
    path: '/',
    redirect: '/login'
  },

  {
    path: '/home',
    name: 'home',
    component: () => import('../views/HomeView.vue')
  },

  {
    path: '/notice/create',
    name: 'noticeCreate',
    component: () => import('../views/NoticeCreateView.vue')
  },

  {
    path: '/notice/modify/:noticeNumber',
    name: 'noticeModify',
    component: () => import('../views/NoticeModifyView.vue'),
    props: true
  },

  {
    path: '/notice/list',
    name: 'noticeList',
    component: () => import('../views/NoticeListView.vue')
  },

  {
    path: '/notice/:noticeNumber',
    name: 'noticeDetail',
    component: () => import('../views/NoticeView.vue'),
    props: true
  },

  {
    path: '/coord',
    name: 'coordMap',
    component: () => import('../views/CoordMapView.vue')
  },

  {
    path: '/news',
    name: 'cityNews',
    component: () => import('../views/CityNewsView.vue')
  },

  {
    path: '/post',
    name: 'postList',
    component: () => import('../views/PostListView.vue')
  },

  {
    path: '/post/:postId/edit',
    name: 'postModify',
    component: () => import('../views/PostModifyView.vue'),
    props: true
  },

  {
    path: '/post/:postId',
    name: 'postDetail',
    component: () => import('../views/PostView.vue'),
    props: true
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})


router.beforeEach((to, from, next) => {
  const token = useAuthStore().token;
  const isAuthenticated = !isEmpty(token);

  if (to.path !== '/login' && !isAuthenticated) {
    next('/login');
  } else if (to.path === '/login' && isAuthenticated) {
    next('/home');
  } else {
    next();
  }
});

function isEmpty(input) {
  return typeof input === 'undefined' ||
      input === null ||
      input === '' ||
      input === 'null' ||
      (Array.isArray(input) && input.length === 0) ||
      (typeof input === 'object' && !Array.isArray(input) && !Object.keys(input).length);
}

export default router
